import React from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { FormattedMessage, useIntl } from 'react-intl';
import Alert from 'react-bootstrap/Alert';
import { fillPlaceholders, useNavigate, paths } from '../routing';
import ErrorMessage from '../components/error-message';
import { TextField } from '../components/fields';
import SubmitButton from '../components/submit-button';
import styles from '../pages/deals/document-template-modal/styles.module.scss';
import { createDocument } from '../utils/api/create-document-from-document-template/create-document-from-document-template';
import { useApolloClient } from '@apollo/client';
import { useNotifications } from '../notifications';
import { useDocumentState } from '../contexts/DocumentContext';
import { documentStateFromResponse } from '../utils/document-wizard-utils/document-state-from-response';

interface TemplateInputFormProps {
  errors: any;
  isSubmitting: boolean;
  isValid: boolean;
}

const TemplateInputForm = ({ errors, isSubmitting, isValid }: TemplateInputFormProps) => (
  <Form noValidate className={styles.templateInputForm}>
    {errors._general && (
      <Alert variant="danger">
        <ErrorMessage>{errors._general}</ErrorMessage>
      </Alert>
    )}
    <div className={styles.templateInputForm__input}>
      <TextField
        id="TemplateInputForm.title"
        name="title"
        type="title"
        label={false}
      />
    </div>

    <SubmitButton
      /*
      // @ts-ignore*/
      label={<FormattedMessage id="cta.create-document" defaultMessage="Create Document" />}
      disabled={isSubmitting || !isValid}
      isSubmitting={isSubmitting}
      data-testid="create-document-button"
    />
  </Form>
);

const schema = yup.object().shape({
  title: yup.string().required(),
});

const TemplateInputFormik = ({
  dealId,
  templateId = null,
  onClose,
  isCreatingLeaseDraft,
  teamId,
}: any) => {
  const apolloClient = useApolloClient();
  const [, { error: notifyError }] = useNotifications();
  const { formatMessage } = useIntl();
  const { updateDocumentState } = useDocumentState();
  const navigate = useNavigate();

  const onSubmit = async (values: any) => {
    isCreatingLeaseDraft();
    createDocument({ dealId, templateId, title: values.title })(apolloClient)
      .then((response) => {
        const navigateUrl = fillPlaceholders(paths.documentPath, { dealId, teamId, documentId: response.id });
        //@ts-ignore
        updateDocumentState(documentStateFromResponse(response));
        navigate(navigateUrl);
      })
      .catch(() => {
        notifyError({
          message: formatMessage({
            id: 'lease-document-wizard.create-offer.error',
            defaultMessage: 'Unable to create a Document',
          }),
        });
      })
      .finally(() => {
        onClose();
      });
  };
  return (
    <Formik validationSchema={schema} onSubmit={onSubmit} component={TemplateInputForm} initialValues={{ title: '' }} />
  );
};

export default TemplateInputFormik;
